export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative w-full aspect-[4/3] max-w-[500px] mx-auto rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20corner%20with%20colorful%20manga%20books%20scattered%20on%20a%20wooden%20table%2C%20soft%20natural%20light%20streaming%20through%20window%2C%20comfortable%20modern%20interior%2C%20artistic%20comic%20culture%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20peaceful%20reading%20vibe%2C%20editorial%20photography%20with%20soft%20shadows&width=1000&height=750&seq=about-manga-platform&orientation=landscape"
                alt="蛙漫漫画平台介绍 - 温馨的漫画阅读体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
              关于蛙漫
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
              让好漫画被更多人看到
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
              蛙漫漫画创立于2022年，是一个专注于为中文读者提供优质漫画阅读体验的在线平台。
            </p>
            <p className="text-sm md:text-base text-foreground-600 mt-3 leading-relaxed">
              我们与国内外多家知名漫画平台和独立创作者建立了深度合作关系，
              致力于打造一个内容丰富、界面清爽、体验流畅的漫画阅读空间。
              从韩漫的唯美画风到日漫的热血剧情，从国漫的崛起新作到经典老番，
              蛙漫漫画始终坚持「免费、正版、优质」的核心理念，
              让每一位漫画爱好者都能在这里找到属于自己的快乐。
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-5 mt-6 text-sm text-foreground-600 flex-wrap">
              <span><strong className="text-primary-600 font-heading">100+</strong> 合作平台</span>
              <span className="w-px h-4 bg-background-300"></span>
              <span><strong className="text-accent-600 font-heading">500万+</strong> 活跃读者</span>
              <span className="w-px h-4 bg-background-300"></span>
              <span><strong className="text-secondary-600 font-heading">3年</strong> 持续运营</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}